import { t } from 'i18next';
import { v7 as uuidv7 } from 'uuid';
import { IRecipe } from "@/interfaces/recipe/recipe";
import { ISelectOption } from "@/interfaces/components/select_option";


export  const loadingRecipe: IRecipe = {
    id: uuidv7(),
    image: '',
    title: '',
    description: '',
    servings: 0,
    prep_time: 0,
    cook_time: 0,
    categories: [],
    diet: [],
    allergens: [],
    cuisine: '',
    ingredients: [],
    instructions: [],
    calories: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
    fibre: 0,
    alcohol: 0,
    draft: false,
    published: true
}

export const cuisineOptions: ISelectOption<string>[] = [
    { id: 1, label: t('components.recipeBuilder.cuisines.african'), value: "african" },
    { id: 2, label: t('components.recipeBuilder.cuisines.asian'), value: "asian" },
    { id: 3, label: t('components.recipeBuilder.cuisines.american'), value: "american" },
    { id: 4, label: t('components.recipeBuilder.cuisines.british'), value: "british" },
    { id: 5, label: t('components.recipeBuilder.cuisines.cajun'), value: "cajun" },
    { id: 6, label: t('components.recipeBuilder.cuisines.caribbean'), value: "caribbean" },
    { id: 7, label: t('components.recipeBuilder.cuisines.chinese'), value: "chinese" },
    { id: 8, label: t('components.recipeBuilder.cuisines.easternEuropean'), value: "eastern_european" },
    { id: 9, label: t('components.recipeBuilder.cuisines.european'), value: "european" },
    { id: 10, label: t('components.recipeBuilder.cuisines.french'), value: "french" },
    { id: 11, label: t('components.recipeBuilder.cuisines.german'), value: "german" },
    { id: 12, label: t('components.recipeBuilder.cuisines.greek'), value: "greek" },
    { id: 13, label: t('components.recipeBuilder.cuisines.indian'), value: "indian" },
    { id: 14, label: t('components.recipeBuilder.cuisines.irish'), value: "irish" },
    { id: 15, label: t('components.recipeBuilder.cuisines.italian'), value: "italian" },
    { id: 16, label: t('components.recipeBuilder.cuisines.japanese'), value: "japanese" },
    { id: 17, label: t('components.recipeBuilder.cuisines.jewish'), value: "jewish" },
    { id: 18, label: t('components.recipeBuilder.cuisines.korean'), value: "korean" },
    { id: 19, label: t('components.recipeBuilder.cuisines.latinAmerican'), value: "latin_american" },
    { id: 20, label: t('components.recipeBuilder.cuisines.mediterranean'), value: "mediterranean" },
    { id: 21, label: t('components.recipeBuilder.cuisines.mexican'), value: "mexican" },
    { id: 22, label: t('components.recipeBuilder.cuisines.middleEastern'), value: "middle_eastern" },
    { id: 23, label: t('components.recipeBuilder.cuisines.nordic'), value: "nordic" },
    { id: 24, label: t('components.recipeBuilder.cuisines.southern'), value: "southern" },
    { id: 25, label: t('components.recipeBuilder.cuisines.spanish'), value: "spanish" },
    { id: 26, label: t('components.recipeBuilder.cuisines.thai'), value: "thai" },
    { id: 27, label: t('components.recipeBuilder.cuisines.vietnamese'), value: "vietnamese" }
];

export const dietOptions: ISelectOption<string>[] = [
    { id: 1, label: t('components.recipeBuilder.diets.dairyFree'), value: 'dairy_free' },
    { id: 2, label: t('components.recipeBuilder.diets.fodmap'), value: 'fodmap' },
    { id: 3, label: t('components.recipeBuilder.diets.glutenFree'), value: 'gluten_free' },
    { id: 4, label: t('components.recipeBuilder.diets.keto'), value: 'keto' },
    { id: 5, label: t('components.recipeBuilder.diets.paleo'), value: 'paleo' },
    { id: 6, label: t('components.recipeBuilder.diets.pescatarian'), value: 'pescatarian' },
    { id: 7, label: t('components.recipeBuilder.diets.vegan'), value: 'vegan' },
    { id: 8, label: t('components.recipeBuilder.diets.vegetarian'), value: 'vegetarian' },
    { id: 9, label: t('components.recipeBuilder.diets.vegetarianEggs'), value: 'vegetarian_eggs' },
    { id: 10, label: t('components.recipeBuilder.diets.vegetarianDairy'), value: 'vegetarian_dairy' },
];

export const allergenOptions: ISelectOption<string>[] = [
    { id: 1, label: t('components.recipeBuilder.allergens.dairy'), value: 'dairy' },
    { id: 2, label: t('components.recipeBuilder.allergens.egg'), value: 'egg' },
    { id: 3, label: t('components.recipeBuilder.allergens.gluten'), value: 'gluten' },
    { id: 4, label: t('components.recipeBuilder.allergens.grain'), value: 'grain' },
    { id: 5, label: t('components.recipeBuilder.allergens.nuts'), value: 'nuts' },
    { id: 6, label: t('components.recipeBuilder.allergens.peanut'), value: 'peanut' },
    { id: 7, label: t('components.recipeBuilder.allergens.seafood'), value: 'seafood' },
    { id: 8, label: t('components.recipeBuilder.allergens.sesame'), value: 'sesame' },
    { id: 9, label: t('components.recipeBuilder.allergens.shellfish'), value: 'shellfish' },
    { id: 10, label: t('components.recipeBuilder.allergens.soy'), value: 'soy' },
    { id: 11, label: t('components.recipeBuilder.allergens.sulphites'), value: 'sulphites' },
    { id: 12, label: t('components.recipeBuilder.allergens.treeNut'), value: 'tree_nut' },
    { id: 13, label: t('components.recipeBuilder.allergens.wheat'), value: 'wheat' },
];

export const recipeCategoryOptions: ISelectOption<string>[] = [
    { id: 1, label: t('components.recipeBuilder.categories.breakfast'), value: 'breakfast' },
    { id: 2, label: t('components.recipeBuilder.categories.lunch'), value: 'lunch' },
    { id: 3, label: t('components.recipeBuilder.categories.dinner'), value: 'dinner' },
    { id: 4, label: t('components.recipeBuilder.categories.dessert'), value: 'dessert' },
    { id: 5, label: t('components.recipeBuilder.categories.snacks'), value: 'snack' },
    { id: 6, label: t('components.recipeBuilder.categories.drinks'), value: 'drink' },
    // { id: 1, label: 'Main Course', value: 'main course' },
    // { id: 2, label: 'Side Dish', value: 'side dish' },
    // { id: 3, label: 'Dessert', value: 'dessert' },
    // { id: 4, label: 'Appetizer', value: 'appetizer' },
    // { id: 5, label: 'Salad', value: 'salad' },
    // { id: 6, label: 'Bread', value: 'bread' },
    // { id: 7, label: 'Breakfast', value: 'breakfast' },
    // { id: 8, label: 'Soup', value: 'soup' },
    // { id: 9, label: 'Beverage', value: 'beverage' },
    // { id: 10, label: 'Sauce', value: 'sauce' },
    // { id: 11, label: 'Marinade', value: 'marinade' },
    // { id: 12, label: 'Fingerfood', value: 'fingerfood' },
    // { id: 13, label: 'Snack', value: 'snack' },
    // { id: 14, label: 'Drink', value: 'drink' },
];